import axios from 'axios';
import { createAction } from 'redux-actions';
import { get_service_endpoint } from 'ServiceEndpoints';
import { flash } from './CommonActions';

const GET_MARKETING_CATEGORIES = createAction('GET_MARKETING_CATEGORIES');
const CREATE_MARKETING_CATEGORY = createAction('CREATE_MARKETING_CATEGORY');

const marketingCategoryEndpoint = get_service_endpoint('fabric');

export const getMarketingCategories = (params) => async (dispatch) => {
  try {
    const res = await axios.get(`${marketingCategoryEndpoint}/marketing/get-all-category`, {
      params,
    });
    dispatch(GET_MARKETING_CATEGORIES(res.data.data));
  } catch (err) {
    dispatch(
      flash({
        message: err.response?.data?.message || 'Failed to fetch marketing categories',
      }),
    );
  }
};

export const createMarketingCategory = (requestData) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${marketingCategoryEndpoint}/marketing/create-category`,
      requestData,
    );
    if (res?.data?.data?.success === false) {
      throw {
        response: { data: { message: res?.data?.data?.message || 'Failed to Create category' } },
      };
    }
    dispatch(CREATE_MARKETING_CATEGORY(res.data.data));
    return res.data;
  } catch (err) {
    dispatch(
      flash({
        message: err.response?.data?.message || 'Failed to create category',
      }),
    );
    throw err;
  }
};
